import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService, User } from '@auth0/auth0-angular';
import { APP_CONFIG, AppConfig } from './app-config';
import * as Sentry from '@sentry/angular';
import { environment } from '@env/environment';
import { filter } from 'rxjs/operators';
import { ServiceWorkerService } from '../core/services/service-worker.service';

@Injectable({
  providedIn: 'root',
})
export class SentryService {

  private readonly appConfig = inject<AppConfig>(APP_CONFIG);
  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly serviceWorkerService = inject(ServiceWorkerService);

  constructor() {
    this.authService.user$.pipe(
      takeUntilDestroyed(this.destroyRef),
      filter(user => !!user),
    ).subscribe((user) => this.initializeSentry(user));
  }

  private initializeSentry(user: User) {
    if (this.appConfig.sentry.enabled) {
      Sentry.init({
        dsn: this.appConfig.sentry.dsn,
        environment: this.appConfig.sentry.environment,
        transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
        release: `fe-qdrive@${environment.version}` // fe-qdrive prefix is mandatory!,
      });

      Sentry.getGlobalScope().setUser({ email: user.email });
      Sentry.getGlobalScope().setTag('online', navigator.onLine);
      Sentry.getGlobalScope().setTag('unsupported-browser', !this.serviceWorkerService.isSupported());
    }
  }
}
